import React, { useEffect, useState, FC, Fragment } from 'react';
import { ApolloQueryResult, useApolloClient } from '@apollo/client';

import { ReadDiffDocument } from './Diff';
import { ReadDiffDocumentQuery } from '../../graphql/__generated__/graphql';
import DiffPrefetchImage from './DiffPrefetchImage';

type Props = {
  prevId?: string;
  nextId?: string;
}

const DiffPrefetch: FC<Props> = ({ prevId, nextId }) => {
  const client = useApolloClient();
  const [diffs, setDiffs] = useState<Array<
    ApolloQueryResult<ReadDiffDocumentQuery> |
    undefined
  >>([]);

  useEffect(() => {
    const fetchData = (id: string) => {
      const options = {
        query: ReadDiffDocument,
        variables: { id },
      };
      const cacheData = client.readQuery(options);

      if (cacheData) {
        return;
      }

      return client.query(options);
    };
    const results: Array<Promise<ApolloQueryResult<ReadDiffDocumentQuery>> | undefined> = [];
    if (nextId) results.push(fetchData(nextId));
    if (prevId) results.push(fetchData(prevId));

    void Promise.all(results.filter(Boolean)).then((res) => {
      setDiffs(res);
    });
  }, [prevId, nextId]);

  return !diffs.length ?
    null : (
      <>
        {diffs.map((diff) => (
          <Fragment key={diff?.data?.diff?.id}>
            <DiffPrefetchImage diffResult={diff!} />
          </Fragment>
        ),
        )}
      </>
    );
};

export default DiffPrefetch;
